export const superAdmin = {
  common: {
    actions: 'Acciones',
  },
  index: {
    title: 'Dashboard Super-Admin',
  },
  organizations: {
    active: 'Activa',
    create: 'Crear Organización',
    createdAt: 'Fecha de Creación',
    deleteDialog: {
      confirm: 'Desactivar Organización',
      deleting: 'Desactivando...',
      description:
        'La organización será marcada como inactiva y no será accesible para los usuarios.',
      title: 'Desactivar Organización',
    },
    description: 'Gestiona y organiza las organizaciones de tu plataforma',
    form: {
      create: {
        description: 'Completa los detalles para crear una nueva organización.',
        submit: 'Crear Organización',
        submitting: 'Creando...',
        title: 'Crear Nueva Organización',
      },
      edit: {
        description: 'Actualiza los detalles de la organización.',
        submit: 'Actualizar Organización',
        submitting: 'Actualizando...',
        title: 'Editar Organización',
      },
      fields: {
        logo: {
          help: 'URL de la imagen del logo de la organización',
          label: 'URL del Logo',
          placeholder: 'https://example.com/logo.png',
        },
        name: {
          label: 'Nombre de la Organización',
          placeholder: 'Acme Inc',
          required: 'El nombre de la organización es requerido',
        },
        slug: {
          help: 'Un identificador único para la organización',
          label: 'Slug',
          placeholder: 'acme-inc',
          required: 'El slug es requerido',
        },
      },
    },
    inactive: 'Inactiva',
    member: 'Miembro',
    members: 'Miembros',
    name: 'Nombre de la Organización',
    organizationDetails: 'Detalles de la Organización',
    restoreDialog: {
      confirm: 'Reactivar Organización',
      description:
        'La organización será marcada como activa y será accesible para los usuarios nuevamente.',
      restoring: 'Reactivando...',
      title: 'Reactivar Organización',
    },
    slug: 'Slug',
    status: 'Estado',
    title: 'Gestión de Organizaciones',
  },
  impersonation: {
    bannerText: 'Estás suplantando a {{name}} ({{email}})',
    stopImpersonating: 'Detener Suplantación',
    minimize: 'Minimizar banner',
    expand: 'Expandir banner de suplantación',
  },
  tabs: {
    organizations: 'Organizaciones',
    users: 'Usuarios',
    demos: 'Demos',
  },
  demos: {
    title: 'Gestión de Demos',
    description: 'Pre-generá demos personalizadas para prospectos comerciales',
    create: 'Crear Demo',
    loading: 'Cargando demos...',
    loadError: 'Error al cargar las demos. Intentá de nuevo.',
    empty: {
      title: 'Aún no hay demos',
      description:
        'Creá tu primera demo personalizada para mostrarle Referent a un prospecto.',
    },
    overallStatus: {
      pending: 'Pendiente',
      generating: 'Generando',
      ready: 'Lista',
      partial: 'Parcial',
      failed: 'Falló',
    },
    artifactStatus: {
      pending: 'Pendiente',
      generating: 'Generando',
      completed: 'Completado',
      failed: 'Falló',
    },
    artifacts: {
      audit: 'Auditoría',
      competitors: 'Competidores',
      companyContext: 'Contexto de empresa',
      brandVoice: 'Brand Voice',
      knowledgeBase: 'Knowledge Base',
      keywordGap: 'Gap de Keywords',
      keywordResearch: 'Keyword Research',
      contentPlan: 'Plan de Contenido',
      contentArticle: 'Artículo',
      deliverables: 'Entregables',
    },
    card: {
      sourceAuditLabel: 'Auditoría fuente',
      createdByLabel: 'Creada por',
      readyAtLabel: 'Lista en',
      costLabel: 'Gasto IA',
      emailLabel: 'Email del demo',
      copyEmail: 'Copiar email',
      emailCopied: 'Email copiado al portapapeles',
      emailCopyError: 'No se pudo copiar el email',
      openAsDemoLabel: 'Abrir como demo',
      openAsDemoDialogTitle: '¿Abrir como el usuario del demo?',
      openAsDemoDialogDescription:
        'Vas a iniciar sesión como el usuario de este demo y salir del panel de admin. Usá el banner de impersonación para volver.',
      openAsDemoConfirm: 'Abrir como demo',
      openAsDemoCancel: 'Cancelar',
    },
    actions: {
      label: 'Acciones',
      regenerate: 'Regenerar artefacto...',
      rotateCredentials: 'Rotar credenciales',
      editSalesNote: 'Editar nota de ventas',
      deleteDemo: 'Eliminar demo',
    },
    form: {
      title: 'Crear Nueva Demo',
      description:
        'Elegí una auditoría completa para la URL del prospecto y vamos a generar una org con los artefactos clonados.',
      submit: 'Crear Demo',
      submitting: 'Creando demo...',
      fields: {
        companyName: {
          label: 'Nombre de la empresa',
          placeholder: 'Nombre de la empresa del prospecto',
          help: 'Se usa para etiquetar la org del demo. Visible para el prospecto al loguearse.',
        },
        auditId: {
          label: 'Auditoría fuente',
          placeholder: 'Seleccioná una auditoría completa',
          search: 'Buscar por URL...',
          empty:
            'No hay auditorías completas con competidores confirmados. Corré primero una auditoría SEO para la URL del prospecto.',
          loading: 'Cargando auditorías...',
          competitors: '{{count}} competidores',
          competitorsOne: '{{count}} competidor',
        },
        salesNote: {
          label: 'Nota de ventas',
          placeholder: 'Contexto opcional sobre el prospecto para vos a futuro.',
          help: 'Guardada en la sesión del demo. Máx 2000 caracteres.',
        },
        forceCreate: {
          label: 'Crear de todas formas',
          description:
            'Ya existe una demo activa para esta auditoría. Marcá esto para crear otra igual.',
        },
      },
      errors: {
        companyNameRequired: 'El nombre de la empresa es requerido',
        companyNameTooShort: 'El nombre debe tener al menos 2 caracteres',
        companyNameTooLong: 'El nombre debe tener como máximo 120 caracteres',
        auditIdRequired: 'Seleccioná una auditoría fuente',
        salesNoteTooLong: 'La nota de ventas debe tener como máximo 2000 caracteres',
      },
    },
    credentialsModal: {
      title: 'Credenciales del demo',
      warning:
        'Estas credenciales se muestran una sola vez. Copialas ahora antes de cerrar.',
      costWarning:
        'Estás acercándote a tu límite diario de gasto IA ($20+ en las últimas 24h).',
      emailLabel: 'Email',
      passwordLabel: 'Contraseña',
      loginUrlLabel: 'URL de login',
      copyEmail: 'Copiar email',
      copyPassword: 'Copiar contraseña',
      copyLoginUrl: 'Copiar URL de login',
      showPassword: 'Mostrar contraseña',
      hidePassword: 'Ocultar contraseña',
      copied: 'Copiado al portapapeles',
      copyError: 'Error al copiar al portapapeles',
      acknowledge: 'Ya copié las credenciales',
      closeWithoutCopy: 'Cerrar sin copiar',
      unsavedConfirmation: 'No copiaste todas las credenciales. ¿Cerrar igual?',
    },
    deleteDialog: {
      title: 'Eliminar demo',
      description:
        'La demo se eliminará (soft-delete) y se sacará de esta lista. No se puede deshacer desde la UI.',
      confirm: 'Eliminar demo',
      cancel: 'Cancelar',
    },
    rotateDialog: {
      title: 'Rotar credenciales',
      description:
        'Se generará una nueva contraseña y se mostrará una sola vez. La contraseña anterior dejará de funcionar.',
      confirm: 'Rotar credenciales',
      cancel: 'Cancelar',
    },
    salesNoteDialog: {
      title: 'Editar nota de ventas',
      description:
        'Nota interna sobre el prospecto. Solo visible para super-admins. Máx 2000 caracteres.',
      placeholder: 'Agregá una nota sobre el prospecto...',
      save: 'Guardar nota',
      cancel: 'Cancelar',
    },
    regenerateDialog: {
      title: 'Regenerar artefacto',
      description:
        'Elegí qué artefacto IA volver a generar. La auditoría y los competidores no se pueden regenerar.',
      artifactLabel: 'Artefacto',
      confirm: 'Regenerar',
      cancel: 'Cancelar',
    },
    toasts: {
      created: 'Demo creada exitosamente',
      createError: 'Error al crear la demo',
      deleted: 'Demo eliminada',
      deleteError: 'Error al eliminar la demo',
      regenerateStarted: 'Regeneración iniciada',
      regenerateError: 'Error al iniciar la regeneración',
      credentialsRotated: 'Credenciales rotadas',
      credentialsRotateError: 'Error al rotar las credenciales',
      salesNoteSaved: 'Nota de ventas guardada',
      salesNoteError: 'Error al guardar la nota de ventas',
    },
    errorCodes: {
      DEMO_AUDIT_NOT_FOUND:
        'La auditoría seleccionada ya no existe. Elegí otra auditoría.',
      DEMO_AUDIT_NOT_COMPLETED: 'La auditoría seleccionada todavía no está completa.',
      DEMO_AUDIT_NO_COMPETITORS:
        'La auditoría seleccionada no tiene competidores confirmados. Corré primero el descubrimiento de competidores.',
      DEMO_DUPLICATE_AUDIT:
        'Ya existe una demo activa para esta auditoría. Marcá "Crear de todas formas" para sobrescribir.',
      DEMO_DAILY_COST_LIMIT_REACHED:
        'Llegaste al tope diario de gasto IA. Intentá de nuevo mañana.',
      DEMO_LIFETIME_COST_LIMIT_REACHED:
        'Esta demo llegó a su tope de gasto IA de $5. Creá una demo nueva.',
      DEMO_ARTIFACT_NOT_REGENERATABLE: 'Este artefacto no se puede regenerar.',
      DEMO_ARTIFACT_BUSY:
        'Este artefacto ya se está regenerando. Esperá a que termine.',
      DEMO_ARTIFACT_PREREQUISITE_MISSING:
        'Falta completar un artefacto previo. Volvé a generarlo primero.',
      DEMO_NOT_FOUND: 'Demo no encontrada.',
      DEMO_PROVISION_FAILED:
        'Error al provisionar la demo. Intentá de nuevo o revisá los logs del servidor.',
      generic: 'Algo salió mal. Intentá de nuevo.',
    },
    filters: {
      searchPlaceholder: 'Buscar por empresa o URL de auditoría...',
      statusLabel: 'Estado',
      statusAll: 'Todos los estados',
    },
    pagination: {
      loadMore: 'Cargar más',
      loading: 'Cargando...',
      showing: 'Mostrando {{count}} de {{total}}',
    },
  },
  orgSwitcher: {
    label: 'Cambiar Organización',
    placeholder: 'Buscar organización',
    noOrganization: 'Sin organización seleccionada',
    noResults: 'Sin resultados',
    openInNewTab: 'Abrir en pestaña nueva',
  },
  toasts: {
    impersonationError: 'Error al iniciar la suplantación',
    impersonationStarted: 'Suplantación iniciada exitosamente',
    impersonationStopped: 'Suplantación detenida exitosamente',
    memberCreated: 'Usuario agregado a la organización exitosamente',
    memberCreateError: 'Error al agregar el usuario a la organización',
    memberRemoved: 'Usuario quitado de la organización',
    memberRemoveError: 'Error al quitar al usuario de la organización',
    memberRoleUpdated: 'Rol actualizado',
    memberRoleUpdateError: 'Error al actualizar el rol',
    organizationCreateError: 'Error al crear la organización',
    organizationCreated: 'Organización creada exitosamente',
    organizationDeleteError: 'Error al eliminar la organización',
    organizationDeleted: 'Organización eliminada exitosamente',
    organizationRestoreError: 'Error al restaurar la organización',
    organizationRestored: 'Organización restaurada exitosamente',
    organizationUpdateError: 'Error al actualizar la organización',
    organizationUpdated: 'Organización actualizada exitosamente',
    passwordCopied: 'Contraseña copiada',
    passwordCopyError: 'Error al copiar',
    passwordCopyErrorDescription: 'No se pudo copiar la contraseña al portapapeles',
    passwordCopySuccess: 'La contraseña ha sido copiada al portapapeles',
    organizationSwitchError: 'Error al cambiar de organización',
    stopImpersonationError: 'Error al detener la suplantación',
    userCreateError: 'Error al crear el usuario',
    userCreated: 'Usuario creado exitosamente',
    userDeleteError: 'Error al eliminar el usuario',
    userDeleted: 'Usuario eliminado exitosamente',
    userRestoreError: 'Error al restaurar el usuario',
    userRestored: 'Usuario restaurado exitosamente',
    userUpdateError: 'Error al actualizar el usuario',
    userUpdated: 'Usuario actualizado exitosamente',
  },
  users: {
    active: 'Activo',
    createdAt: 'Fecha de Creación',
    create: 'Crear Usuario',
    impersonate: 'Suplantar Usuario',
    deleteDialog: {
      confirm: 'Desactivar Usuario',
      deleting: 'Desactivando...',
      description: 'El usuario será marcado como inactivo y no podrá acceder a la plataforma.',
      title: 'Desactivar Usuario',
    },
    description:
      'Gestiona y monitorea los usuarios de la plataforma y sus membresías organizacionales',
    form: {
      create: {
        description: 'Completa los detalles para crear un nuevo usuario.',
        submit: 'Crear Usuario',
        submitting: 'Creando...',
        title: 'Crear Nuevo Usuario',
      },
      edit: {
        description: 'Actualiza los detalles del usuario.',
        submit: 'Actualizar Usuario',
        submitting: 'Actualizando...',
        title: 'Editar Usuario',
      },
      fields: {
        lastName: {
          label: 'Apellido',
          placeholder: 'Pérez',
          required: 'El apellido es requerido',
        },
        linkedin: {
          label: 'URL de LinkedIn',
          placeholder: 'https://linkedin.com/in/juanperez',
        },
        name: {
          label: 'Nombre',
          placeholder: 'Juan',
          required: 'El nombre es requerido',
        },
        organization: {
          label: 'Organización',
          placeholder: 'Seleccionar una organización',
          required: 'La organización es requerida',
        },
        position: {
          label: 'Posición',
          placeholder: 'Ingeniero de Software',
        },
        timezone: {
          label: 'Zona Horaria',
        },
      },
      passwordInfo:
        'La contraseña se genera automáticamente. Para poder crear el nuevo usuario, es necesario copiarla.',
      passwordInfoEdit:
        'Deja vacía para mantener la contraseña actual, haz clic en el botón regenerar para generar una nueva contraseña. Después de modificar la contraseña, debes copiarla para poder actualizar el usuario.',
    },
    inactive: 'Inactivo',
    memberships: {
      title: 'Organizaciones',
      description: 'Los cambios en organizaciones se aplican al instante.',
      deactivated: 'Desactivada',
      empty: 'El usuario no pertenece a ninguna organización',
      lastOrganizationHint: 'Un usuario debe pertenecer al menos a una organización.',
      roleLabel: 'Rol en {{organization}}',
      add: {
        title: 'Agregar organización',
        organizationPlaceholder: 'Selecciona una organización',
        noOptions: 'No hay organizaciones disponibles',
        loading: 'Cargando organizaciones...',
        roleLabel: 'Rol en la nueva organización',
        submit: 'Agregar',
      },
      remove: {
        label: 'Quitar de {{organization}}',
        confirmTitle: '¿Quitar de {{organization}}?',
        confirmDescription:
          'El usuario perderá acceso a {{organization}} y se cerrarán todas sus sesiones activas. Deberá volver a iniciar sesión.',
        confirm: 'Quitar',
      },
      errors: {
        alreadyMember: 'El usuario ya es miembro de esta organización.',
        lastOrganization: 'No se puede quitar al usuario de su última organización.',
        organizationInactive: 'Esta organización está desactivada. No se pueden agregar usuarios.',
        organizationNotFound: 'La organización no existe.',
        memberNotFound: 'Esta membresía ya no existe. Actualiza e intenta de nuevo.',
        validation: 'La solicitud no es válida. Revisa la organización y el rol elegidos.',
      },
    },
    name: 'Nombre de Usuario',
    noOrganization: 'Sin Organización',
    organization: 'Organización',
    organizations: 'Organizaciones',
    restoreDialog: {
      confirm: 'Reactivar Usuario',
      description:
        'El usuario será marcado como activo y podrá acceder a la plataforma nuevamente.',
      restoring: 'Reactivando...',
      title: 'Reactivar Usuario',
    },
    role: 'Rol',
    status: 'Estado',
    title: 'Gestión de Usuarios',
  },
} as const
